import React from 'react';
import LegalPage from './LegalPage';

export default function PrivacyPolicy() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="July 2026">
      <h2>1. Introduction</h2>
      <p>
        Bombay Coding Consultancy LLP ("Bombay Coding Company," "we," "our," or "us") respects your privacy and is deeply committed to protecting your personal data. 
        This Privacy Policy outlines how we collect, process, and safeguard the personal identification information of visitors profiling our portfolio ("Users"), as well as clients engaging our software development services. 
        We comply strictly with the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 of India, maintaining broad alignment with GDPR data handling standards.
      </p>

      <h2>2. Information We Collect</h2>
      <p>
        We may collect personal data from Users in various ways, primarily when Users engage with our lead capture forms, sign up for architecture scoping sessions, or subscribe to updates. The data we collect includes:
      </p>
      <ul>
        <li><strong>Identity & Contact Data:</strong> Full name, email address, phone numbers, and associated corporate identifiers (e.g., Company Registration).</li>
        <li><strong>Project Scoping Data:</strong> Details about your software requirements, architectural constraints, budget estimations, and specific tech stack requests generated through our contact pipelines.</li>
        <li><strong>Technical Data:</strong> IP addresses, browser types, timezone settings, and operating system data used to ensure platform security and optimize our cinematic User Interface performance.</li>
      </ul>

      <h2>3. How We Process & Use Information</h2>
      <p>
        As a Data Controller for our website leads, and a Data Processor for our clients' proprietary software architectures, we only use your data under safe, lawful bases:
      </p>
      <ul>
        <li><strong>Contractual Necessity:</strong> To fulfill software development contracts, communicate project roadmaps, and provide architectural consultation.</li>
        <li><strong>Service Optimization:</strong> To monitor and analyze website metrics, ensuring our robust UI interfaces and backend APIs function optimally across different devices.</li>
        <li><strong>Client Communication:</strong> To send rapid notifications regarding project status, billing, or security alerts. We do not engage in unsolicited promotional spam.</li>
      </ul>

      <h2>4. Data Storage, Security, & Architecture</h2>
      <p>
        We construct enterprise-grade solutions and apply the same rigor to our own data security. Your information is stored securely utilizing modern encryption protocols (AES-256 for at-rest storage and TLS 1.3 for transit). 
        We implement strict internal access controls; only authorized engineers with a verified "need-to-know" clearance have access to sensitive client project repositories or scoping data.
      </p>

      <h2>5. Sharing Your Personal Information</h2>
      <p>
        <strong>We strictly do not sell, trade, or rent User or Client personal data to third parties.</strong>
      </p>
      <p>
        Information is only securely routed through our trusted infrastructure partners (such as AWS, Vercel, MongoDB, or certified analytics providers) exclusively for the purpose of operating our website or hosting isolated client development environments. All trusted affiliates are bound by strict NDA and GDPR-compliant processing addendums.
      </p>

      <h2>6. Your Data Rights</h2>
      <p>
        Depending on your jurisdiction, you maintain robust rights over your personal data. You may request to:
      </p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Correct inaccuracies within your data profile.</li>
        <li>Request deletion (the "Right to be Forgotten") of your lead data, provided we are not required to retain it for legal or accounting taxation purposes under Indian law.</li>
      </ul>

      <h2>7. Contacting Our Data Protection Officer</h2>
      <p>
        If you wish to exercise your data rights, audit our security frameworks, or ask a question regarding this policy, please reach out to our team at our headquarters:<br />
        <strong>Bombay Coding Consultancy LLP</strong><br />
        1/11, Sai Skrupa Seva Society, Ghartan Pada No. 2,<br />
        Dahisar East, Mumbai – 400068, India
      </p>
    </LegalPage>
  );
}
